import { Component, OnInit, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

export const LAAS_INPUT_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputSetComponent),
  multi: true
};
@Component({
  selector: 'laas-input-set',
  templateUrl: './input-set.component.html',
  styleUrls: ['./input-set.component.scss'],
  providers: [LAAS_INPUT_ACCESSOR]
})
export class InputSetComponent implements OnInit {

  @Input() maxlength: any;
  @Output() onBlur: EventEmitter<any> = new EventEmitter();
  @Output() onPress: EventEmitter<any> = new EventEmitter();

  value: any;
  changeText: boolean;
  onChange!: (value: string) => void;
  onTouched!: () => void;
  disabled = false;

  constructor( private fb: FormBuilder) {
    this.changeText = false;
    this.value = '';
   }

  blur(event: any): void{
    this.changeText = false
    this.onBlur.emit({
      originalevent:event,
      value: this.value
    });
  }
  focus(event: any): void{
    this.changeText = true
    this.onPress.emit({
      originalevent:event,
      value: this.value
    });
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
  }


}
